import React from 'react'

interface Props {
    value: number
    class: string
    showPlusSign: boolean
}
class Percent extends React.Component<Props> {
    public static defaultProps = {
        value: 0,
        class: '',
        showPlusSign: false,
    }

    public render() {
        let decimals = 0
        const className = 'unit ' + this.props.class
        const showPlusSign = this.props.showPlusSign ? this.props.showPlusSign : false

        if (isNaN(this.props.value)) {
            return <span className={className}>-</span>
        }

        // We could use Math.log to determine this, but I guess this is more
        // readable…
        if (this.props.value < 0.01) {
            decimals = 2
        } else if (this.props.value < 0.1) {
            decimals = 1
        }
        const showSign = this.props.value >= 0 && showPlusSign ? '+' : ''
        return (
            <span className={className}>
                {showSign}
                {(this.props.value * 100).toFixed(decimals)}%
            </span>
        )
    }
}

export default Percent
